<template>
  <!-- SISTEMA -->
  <CDropdown
    v-auth-roles="{
      user: userAuth,
      roles: [const_roles.ROLE_SYSTEM],
    }"
    togglerText="Sistema"
    nav
    placement="bottom-end"
  >
    <CDropdownItem
      @click="tMenu"
      v-auth-roles="{
        user: userAuth,
        roles: [const_roles.ROLE_SYSTEM],
      }"
      to="/usuarios"
      >Usuarios</CDropdownItem
    >
  </CDropdown>
</template>
<script>
import Constants from "@/plugins/constants";
export default {
  name: "SystemMenu",
  props: ["toggleMenu"],
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  data() {
    return {
      const_roles: Constants.roles,
    };
  },
  methods: {
    tMenu() {
      this.toggleMenu();
    },
  },
};
</script>